import React from "react";

const InventoryDesktop = React.lazy(() => import("./ui/Inventory"));

export const InventoryClientPage = () => {
  return <InventoryDesktop />;
};
